var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5706 8.72099C2.29409 8.72099 2.03572 8.62882 1.84987 8.45767C1.61416 8.24262 1.50084 7.91786 1.54164 7.56677L1.70935 6.14485C1.74108 5.87715 1.9088 5.52167 2.10371 5.32857L5.82519 1.51484C6.75443 0.5625 7.72446 0.536168 8.70809 1.43584C9.69173 2.33551 9.71892 3.27468 8.78969 4.22702L5.0682 8.04075C4.87782 8.23823 4.52426 8.42256 4.24776 8.46644L2.78817 8.70782C2.71112 8.71221 2.64312 8.72099 2.5706 8.72099ZM7.28024 1.43145C6.93121 1.43145 6.62751 1.64211 6.31928 1.95809L2.59779 5.77621C2.50714 5.86837 2.40288 6.0878 2.38475 6.21507L2.21703 7.63699C2.1989 7.78182 2.23516 7.90031 2.31676 7.97492C2.39835 8.04952 2.52074 8.07585 2.67032 8.05391L4.1299 7.81254C4.26135 7.79059 4.47893 7.67649 4.56959 7.58433L8.29107 3.7706C8.85315 3.1913 9.05713 2.65588 8.23668 1.90981C7.87405 1.57189 7.56128 1.43145 7.28024 1.43145Z",
    fill: "#5571C6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.53895 4.36713C8.52985 4.36713 8.51619 4.36713 8.50708 4.36713C7.08636 4.2435 5.94342 3.29833 5.72485 2.06202C5.69752 1.89851 5.82502 1.74696 6.01172 1.71905C6.19842 1.69512 6.37145 1.80679 6.40333 1.9703C6.57636 2.93541 7.46886 3.67719 8.57994 3.77291C8.76663 3.78886 8.90324 3.93642 8.88502 4.09993C8.86226 4.25148 8.71199 4.36713 8.53895 4.36713Z",
    fill: "#5571C6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit_icon.96686b75f0b7ffcc6712d633fcd86d7b.svg";
export { ForwardRef as ReactComponent };